import React from 'react';
import Auth from '../Auth/Auth';
import { Button } from 'react-bootstrap';
import { fetchAPI } from './FetchAPIWrapper';

const auth = new Auth();
    
async function FeatureClickTracker(FeatureClicked){ 

    let featureTracker = {
        FeatureClicked : FeatureClicked,
    };

    if(sessionStorage.getItem("cerebroSession") && sessionStorage.getItem("cerebroSession") !== undefined){
        let session = JSON.parse(sessionStorage.getItem("cerebroSession"));
        featureTracker.sessionId = session.sessionId;
      }

    let accessToken = await auth.getToken();  
    //Adding smart panel click to DB        
    fetch(`/api/FeatureTracker`,{
        method : "POST",
        headers : {
        "Content-Type": "application/json",
        'Authorization': "Bearer " + accessToken,
        withCredentials : true,
        crossDomain: true,
        },
        body: JSON.stringify(featureTracker)
    }).then(response => {
        if(response.status !== 200)
        {   
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
              };
        }
        return  response.json();
      }).then(success => {
    }).catch((error) => {
        window.apiError(error);
    });
}

function setSmartClickTracker(self){
    setTimeout(function(){
        var smartPanel = document.querySelectorAll('[data-track="true"]');
        for(var i = 0; i < smartPanel.length; i++){
            smartPanel[i].addEventListener('click', function(event){
                let x = event.target.closest('[data-track="true"]');
                let trackerName = x.getAttribute("name");

                //Adding smart panel click to DB
                SmartClickTracker( trackerName, self);
            });
        }
    },1500);
}

async function SmartClickTracker(trackerName, self){
    let accessToken = await auth.getToken();

    let smartData = {
        SearchURL: self.props.mainSearch,
        SmartPanelClick: trackerName
    };

    if(sessionStorage.getItem("cerebroSession") && sessionStorage.getItem("cerebroSession") !== undefined){
        let session = JSON.parse(sessionStorage.getItem("cerebroSession"));
        smartData.sessionId = session.sessionId;
      }
        //Adding smart panel click to DB

    fetch(`/api/smartPanelTracker`,{
        method : "POST",
        headers : {
        "Content-Type": "application/json",
        'Authorization': "Bearer " + accessToken,
        withCredentials : true,
        crossDomain: true,
        },
        body: JSON.stringify(smartData)
    }).then(response => {
        if(response.status !== 200)
        {
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
              };
        }
        return  response.json();
    })
    .then(success => {
    }).catch((error) => {
        window.apiError(error);
    });
}

function removeImagesFromHTML(html){
    try {
        html = `<div class="reply-item shadow-sm" data-id="0D71Y00000541yzSAA"><div class="left-block"><div class="name-circle"></div></div><div class="right-block"><h6 class="font-weight-bold">The Budd Group</h6><small class="float-left w-100  mb-3">2020-02-18</small><h6><p>I started with Add&gt;Add Report (not Add Report from Topic) and it's in either Audit or Time &amp; Attendance.<img src="sfdc://0691Y000007TA9OQAW" alt="audit"></p></h6></div></div>`
        let htmlContainer = document.createElement("div");
        htmlContainer.innerHTML = html;
        let imageTags = htmlContainer.getElementsByTagName('img');
        while(imageTags.length > 0) {
            imageTags[0].parentNode.removeChild(imageTags[0]);
        }
    
        let cleanHtml = htmlContainer.innerHTML;
        return  cleanHtml;
    } catch {
        return html;
    }
    
}

async function startCerebroSession(CerebroSession){
    let accessToken = await auth.getToken();  

    CerebroSession.SessionEnd = null;

    fetch(`/api/CerebroSession`,{
        method : "POST",
        headers : {
        "Content-Type": "application/json",
        'Authorization': "Bearer " + accessToken,
        withCredentials : true,
        crossDomain: true,
        },
        body: JSON.stringify(CerebroSession)
    }).then(response => {
        if(response.status !== 200)
        {   
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
            };
        }
        return  response.json();
    }).catch((error) => {
        window.apiError(error);
    });
}

async function EndSessionTable(isAutoClose){
    if(sessionStorage.getItem("cerebroSession") && sessionStorage.getItem("cerebroSession") !== undefined){
        let accessToken = await auth.getToken();  
        let CerebroSession = JSON.parse(sessionStorage.getItem("cerebroSession"));
        CerebroSession.SessionEnd = new Date();
        CerebroSession.isAutoClose = isAutoClose;

        fetch(`/api/EndCerebroSession`,{
            method : "POST",
            headers : {
            "Content-Type": "application/json",
            'Authorization': "Bearer " + accessToken,
            withCredentials : true,
            crossDomain: true,
            },
            body: JSON.stringify(CerebroSession)
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        }).then(success => {
            sessionStorage.removeItem("cerebroSession");
            sessionStorage.setItem("recentlyClosedCase",JSON.stringify(CerebroSession));
        }).catch((error) => {
            window.apiError(error);
        });
    }
}

async function updateSessionTable(isAutoClose){
    if(sessionStorage.getItem("cerebroSession") && sessionStorage.getItem("cerebroSession") !== undefined){
        let accessToken = await auth.getToken();  
        let CerebroSession = JSON.parse(sessionStorage.getItem("cerebroSession"));
        CerebroSession.SessionEnd = new Date();
        CerebroSession.isAutoClose = isAutoClose;

        fetch(`/api/CerebroSession`,{
            method : "POST",
            headers : {
            "Content-Type": "application/json",
            'Authorization': "Bearer " + accessToken,
            withCredentials : true,
            crossDomain: true,
            },
            body: JSON.stringify(CerebroSession)
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json()
        }).then(success => {
            sessionStorage.removeItem("cerebroSession");
            sessionStorage.setItem("recentlyClosedCase",JSON.stringify(CerebroSession));
        }).catch((error) => {
            window.apiError(error);
        });
    }
}

async function updateSessionTableOnUnload(){
    let accessToken = await auth.getToken();
    let CerebroSession = JSON.parse(sessionStorage.getItem("cerebroSession"));
    CerebroSession.SessionEnd = new Date();
    CerebroSession.auth =  "Bearer " + accessToken;
    
    let headers = {
        type: 'application/json'
    };

    let blob = new Blob([JSON.stringify(CerebroSession)], headers);
    if("sendBeacon" in navigator)
    {
        navigator.sendBeacon("/unloadCerebroSession", blob);
        sessionStorage.removeItem("cerebroSession");
    }
    else
    {
        var client = new XMLHttpRequest();
        client.open("POST", "/unloadCerebroSession", false);
        client.send(blob);
        sessionStorage.removeItem("cerebroSession");
    }
} 

function AutoClosedCase(props){

    let CerebroSession = JSON.parse(sessionStorage.getItem("recentlyClosedCase"));
    if(CerebroSession){
        const link = `D365/QuickView/${CerebroSession.cerebroCaseId}`;
        const title = CerebroSession.cerebroCaseTitle;
        const CRMId = CerebroSession.cerebroCaseId;
        return (
            <div>
                <p className="m-0" style={{lineHeight : 1}}>
                We closed your instance of Fetch Pro: Case #{CerebroSession.cerebroCaseNumber}
                <br />
                To reopen, click <Button variant="link" style={{color: "white", padding: "0px", verticalAlign: "baseline", textDecoration: "underline" }} onClick={() => { window.history.pushState(null,null, `/q?cerebro&CRMId=${CRMId}`); props.initQuickViewer(link, title)} }>here</Button>
                </p>
            </div>
        );
    }

    return null;
}

function record(self) {
    let queryInput =  document.getElementById('search-query');
    self.setState({
        mainSearch : ''
    });
    queryInput.value = '';
    
    window.SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;
    const recognition = new window.SpeechRecognition();
    recognition.lang = "en-GB";
    queryInput.setAttribute("placeholder","listening...")

    recognition.onresult = function(event) {
        self.setState({
            mainSearch : event.results[0][0].transcript
        });
        queryInput.value = event.results[0][0].transcript;
    };

    recognition.onaudioend = function(){
        queryInput.removeAttribute("placeholder")
    };
    recognition.start();
}

function recordEventListeners(){
    window.addEventListener("load", function () {
        var speechBlock = document.getElementById("speechToText");
        // [1] CHECK IF BROWSER SUPPORTS SPEECH RECOGNITION
        if (window.hasOwnProperty('SpeechRecognition') || window.hasOwnProperty('webkitSpeechRecognition')) {
            if(speechBlock){
                speechBlock.style.display = "block";
            }                
        }
      });
    
    setTimeout(function(){
        let node = document.getElementById("search-query");
        if(node.ownerDocument === document && node.getBoundingClientRect().left > 100) {
            let x = document.getElementsByClassName("main-search")[0];
            x.focus();
        }          
    },400);
}

function inappropriateWords(fieldValue){
    let badWords =  ["4r5e", "5h1t", "5hit", "a55", "anal", "anus", "ar5e", "arrse", "arse", "ass", "ass-fucker", "asses", "assfucker", "assfukka", "asshole", "assholes", "asswhole", "a_s_s", "b!tch", "b00bs", "b17ch", "b1tch", "ballbag", "balls", "ballsack", "bastard", "beastial", "beastiality", "bellend", "bestial", "bestiality", "bi+ch", "biatch", "bitch", "bitcher", "bitchers", "bitches", "bitchin", "bitching", "bloody", "blow job", "blowjob", "blowjobs", "boiolas", "bollock", "bollok", "boner", "boob", "boobs", "booobs", "boooobs", "booooobs", "booooooobs", "breasts", "buceta", "bugger", "bum", "bunny fucker", "butt", "butthole", "buttmuch", "buttplug", "c0ck", "c0cksucker", "carpet muncher", "cawk", "chink", "cipa", "cl1t", "clit", "clitoris", "clits", "cnut", "cock", "cock-sucker", "cockface", "cockhead", "cockmunch", "cockmuncher", "cocks", "cocksuck", "cocksucked", "cocksucker", "cocksucking", "cocksucks", "cocksuka", "cocksukka", "cok", "cokmuncher", "coksucka", "coon", "cox", "crap", "cum", "cummer", "cumming", "cums", "cumshot", "cunilingus", "cunillingus", "cunnilingus", "cunt", "cuntlick", "cuntlicker", "cuntlicking", "cunts", "cyalis", "cyberfuc", "cyberfuck", "cyberfucked", "cyberfucker", "cyberfuckers", "cyberfucking", "d1ck", "damn", "dick", "dickhead", "dildo", "dildos", "dink", "dinks", "dirsa", "dlck", "dog-fucker", "doggin", "dogging", "donkeyribber", "doosh", "duche", "dyke", "ejaculate", "ejaculated", "ejaculates", "ejaculating", "ejaculatings", "ejaculation", "ejakulate", "f u c k", "f u c k e r", "f4nny", "fag", "fagging", "faggitt", "faggot", "faggs", "fagot", "fagots", "fags", "fanny", "fannyflaps", "fannyfucker", "fanyy", "fatass", "fcuk", "fcuker", "fcuking", "feck", "fecker", "felching", "fellate", "fellatio", "fingerfuck", "fingerfucked", "fingerfucker", "fingerfuckers", "fingerfucking", "fingerfucks", "fistfuck", "fistfucked", "fistfucker", "fistfuckers", "fistfucking", "fistfuckings", "fistfucks", "flange", "fook", "fooker", "fuck", "fucka", "fucked", "fucker", "fuckers", "fuckhead", "fuckheads", "fuckin", "fucking", "fuckings", "fuckingshitmotherfucker", "fuckme", "fucks", "fuckwhit", "fuckwit", "fudge packer", "fudgepacker", "fuk", "fuker", "fukker", "fukkin", "fuks", "fukwhit", "fukwit", "fux", "fux0r", "f_u_c_k", "gangbang", "gangbanged", "gangbangs", "gaylord", "gaysex", "goatse", "God", "god-dam", "god-damned", "goddamn", "goddamned", "hardcoresex", "hell", "heshe", "hoar", "hoare", "hoer", "homo", "hore", "horniest", "horny", "hotsex", "jack-off", "jackoff", "jap", "jerk-off", "jism", "jiz", "jizm", "jizz", "kawk", "knob", "knobead", "knobed", "knobend", "knobhead", "knobjocky", "knobjokey", "kock", "kondum", "kondums", "kum", "kummer", "kumming", "kums", "kunilingus", "l3i+ch", "l3itch", "labia", "lust", "lusting", "m0f0", "m0fo", "m45terbate", "ma5terb8", "ma5terbate", "masochist", "master-bate", "masterb8", "masterbat*", "masterbat3", "masterbate", "masterbation", "masterbations", "masturbate", "mo-fo", "mof0", "mofo", "mothafuck", "mothafucka", "mothafuckas", "mothafuckaz", "mothafucked", "mothafucker", "mothafuckers", "mothafuckin", "mothafucking", "mothafuckings", "mothafucks", "mother fucker", "motherfuck", "motherfucked", "motherfucker", "motherfuckers", "motherfuckin", "motherfucking", "motherfuckings", "motherfuckka", "motherfucks", "muff", "mutha", "muthafecker", "muthafuckker", "muther", "mutherfucker", "n1gga", "n1gger", "nazi", "nigg3r", "nigg4h", "nigga", "niggah", "niggas", "niggaz", "nigger", "niggers", "nob", "nob jokey", "nobhead", "nobjocky", "nobjokey", "numbnuts", "nutsack", "orgasim", "orgasims", "orgasm", "orgasms", "p0rn", "pawn", "pecker", "penis", "penisfucker", "phonesex", "phuck", "phuk", "phuked", "phuking", "phukked", "phukking", "phuks", "phuq", "pigfucker", "pimpis", "piss", "pissed", "pisser", "pissers", "pisses", "pissflaps", "pissin", "pissing", "pissoff", "poop", "porn", "porno", "pornography", "pornos", "prick", "pricks", "pron", "pube", "pusse", "pussi", "pussies", "pussy", "pussys", "rectum", "retard", "rimjaw", "rimming", "s hit", "s.o.b.", "sadist", "schlong", "screwing", "scroat", "scrote", "scrotum", "semen", "sex", "sh!+", "sh!t", "sh1t", "shag", "shagger", "shaggin", "shagging", "shemale", "shi+", "shit", "shitdick", "shite", "shited", "shitey", "shitfuck", "shitfull", "shithead", "shiting", "shitings", "shits", "shitted", "shitter", "shitters", "shitting", "shittings", "shitty", "skank", "slut", "sluts", "smegma", "smut", "snatch", "son-of-a-bitch", "spac", "spunk", "s_h_i_t", "t1tt1e5", "t1tties", "teets", "teez", "testical", "testicle", "tit", "titfuck", "tits", "titt", "tittie5", "tittiefucker", "titties", "tittyfuck", "tittywank", "titwank", "tosser", "turd", "tw4t", "twat", "twathead", "twatty", "twunt", "twunter", "v14gra", "v1gra", "vagina", "viagra", "vulva", "w00se", "wang", "wank", "wanker", "wanky", "whoar", "whore", "willies", "willy", "xrated", "xxx"];
    for (let i = 0; i < badWords.length; i++)
    {
        var rgx = new RegExp(["\\b" + badWords[i] + "\\b"], 'gi');
        if (rgx.test(fieldValue))
        {
            return true;   
        }							
    }

    return false;
}

async function getNamespaceDump() {
    return fetchAPI.get(`/api/NamespaceDump`)
    .then(namespaceData => {
        const namespaces = namespaceData.map(el => el.CER_NAMESPACE);
        const clientName = namespaceData.map(el => el.name);
        return {namespaces, clientName }
    }).catch(error => {
        window.apiError(error);
    });
}

/*
 * Group an array by a particular key -- analogous to SQL's GROUP BY aggregation
 *
 * @param {arr} array of objects of any type
 * @param {extractKeyField} function of type function(obj) returning the value of a particular field
 * @returns an object where the keys are the extracted field values and the values are lists of objects with that key+value
 * 
 * e.g.
 *    groupBy([{ foo: 'a', bar: 1 }, { foo: 'a', bar: 2 }, { foo: 'b', bar: 3}], (o) => o.foo);
 * 
 *    will return
 *    {
 *        a: [{ foo: 'a', bar: 1 }, { foo: 'a', bar: 2 }],
 *        b: [{ foo: 'b', bar: 3}]
 *    }
 */
// TODO: reuse in refactoring at a later date
const groupBy = function (arr, extractKeyField) {
    return arr.reduce(function (map, obj) {
        var key = extractKeyField(obj);
        if (!(key in map)) {
            map[key] = [];
        }
        map[key].push(obj);
        return map;
    }, {});
};

export { FeatureClickTracker, removeImagesFromHTML, startCerebroSession, updateSessionTable, EndSessionTable, updateSessionTableOnUnload, setSmartClickTracker, SmartClickTracker, AutoClosedCase, record, recordEventListeners, inappropriateWords, getNamespaceDump }
